import { z } from 'zod'

import { ConversionsApiChannelSchema } from './ConversionsApiChannelSchema'
import { ConversionsApiValueSchema } from './ConversionsApiValueSchema'

export const ConversionsApiSchema = z
  .partialRecord(ConversionsApiChannelSchema, ConversionsApiValueSchema)
  .nullable()
